export default class ClientRoles {
  constructor(api) {
    this.api = api;
  }

  getAll(includes, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/client-roles" + (includes ? "?include=" + includes : ""))
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllParams(queryParams = null, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/accesscontrol/roles" + (params === "" ? "?include=company,permissions,users" : params + "&include=company,permissions,users"))
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllParamsId(id, queryParams = null, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
    .get("v1/accesscontrol/roles/" + id + (params === "" ? "?include=company,permissions,users" : params + "&include=company,permissions,users"))
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByUuid(uuid, includes, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/accesscontrol/roles/" + uuid + (includes ? "?include=" + includes : ""))
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/accesscontrol/roles/", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/accesscontrol/roles/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/accesscontrol/roles/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/client_roles.js